import { ReactNode } from 'react';

import Carousel from '../../../components/Carousel/Carousel';
import Figure from '../../../components/Figure/Figure';
import Vignette from '../../../components/Vignette/Vignette';
import Media from '../../types/Media';

import styles from './MediaCarousel.module.css';

type MediaCarouselProps<TVariantNames extends string> = {
    media: Array<Media<TVariantNames>>;
    variant: TVariantNames;
    children?: ReactNode;
};

const MediaCarousel = <TVariantNames extends string>({
    media,
    children,
    variant,
}: MediaCarouselProps<TVariantNames>) => {
    const overlay = children && (
        <>
            <div className={styles.Vignette}>
                <Vignette type="bottomLeft" />
            </div>
            <div className={styles.OverlayContent}>{children}</div>
        </>
    );

    return (
        <div className={styles.Root}>
            <Carousel overlays={overlay}>
                {media.map((item) => (
                    <Figure
                        src={item.variants[variant].path}
                        defaultPlaceholderRatio={1 / 2}
                        key={item.id}
                    />
                ))}
            </Carousel>
        </div>
    );
};

export default MediaCarousel;
